import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "redux/actions/Index";
import {
  ICreateCampaignRequestPayload,
  IGetQueryParams,
} from "interfaces/Index";
import CampaignPage from "components/pages/campaign/CampaignPage";
import { RootState } from "redux/reducers/RootReducer";

export const mapStateToProps = (state: RootState, props: any): any => {
  const {
    campaign: {
      isLoading,
      pagination,
      campaigns,
      isCampaignFetched,
      isCampaignFetchedError,
      isError,
      error,
      isCampaignCreated,
      isCampaignUpdated,
    },
    product: { productBrands },
  } = state;
  return {
    isLoading,
    pagination,
    campaigns,
    isCampaignFetched,
    isCampaignFetchedError,
    isError,
    error,
    isCampaignCreated,
    isCampaignUpdated,
    productBrands,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    createCampaign: (payload: ICreateCampaignRequestPayload) =>
      dispatch(actions.createCampaign(payload)),
    fetchCampaigns: (queryParams?: IGetQueryParams) =>
      dispatch(actions.getCampaigns(queryParams)),
    updateCampaign: (campaignId: string) =>
      dispatch(actions.updateCampaign(campaignId)),
    fetchProductBrands: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.fetchProductBrands(queryPrams)),
  };
};

const CampaignContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignPage);
export default CampaignContainer;
